var map = {
	"./C2-logo-vector_New.svg": 8941,
	"./CAKES.svg": 7672,
	"./Choco-Almond-FB.svg": 3900,
	"./DECORATION.svg": 5363,
	"./FLOWERS.svg": 1467,
	"./PARTY PROPS.svg": 997,
	"./PHOTOS.svg": 3210,
	"./add-ons/Bouquet.svg": 5945,
	"./add-ons/HBD.svg": 6928,
	"./add-ons/LED.svg": 2665,
	"./add-ons/LED_Numbers_back.svg": 5704,
	"./add-ons/fog_effect.svg": 3030,
	"./add-ons/fog_effect_old.svg": 5440,
	"./add-ons/hbdletters.svg": 5443,
	"./add-ons/led_numbers.svg": 8454,
	"./add-ons/party_props.svg": 2373,
	"./add-ons/photoclippings.svg": 5263,
	"./ballon.svg": 4601,
	"./birthday-cake.svg": 7471,
	"./birthday.svg": 2378,
	"./cakes-images/BisCoffSC.svg": 6720,
	"./cakes-images/Black Currant Blast FB.svg": 2794,
	"./cakes-images/Black ForestSC.svg": 2148,
	"./cakes-images/Blueberry Blast FB.svg": 9888,
	"./cakes-images/Butterscotch_Blast_FB.svg": 5820,
	"./cakes-images/Choco Almond FB.svg": 6795,
	"./cakes-images/Choco ChipSC.svg": 3688,
	"./cakes-images/Choco-strawberry FB.svg": 4190,
	"./cakes-images/Choco-vanilla-FB.svg": 3199,
	"./cakes-images/Choheartcake.svg": 3026,
	"./cakes-images/Disney Princess Birthday Cake FB.svg": 3414,
	"./cakes-images/Ferro Blast FB.svg": 5426,
	"./cakes-images/FruitSC.svg": 2174,
	"./cakes-images/Mexican CakeSC.svg": 4217,
	"./cakes-images/Milky Blast FB.svg": 2422,
	"./cakes-images/Pineapple Blast FB.svg": 330,
	"./cakes-images/Rasamalai Blast FB.svg": 8219,
	"./cakes-images/Red heart cakeFB.svg": 3453,
	"./cakes-images/RedVelvetBlastFB.svg": 1517,
	"./cakes-images/White Forest Blast FB.svg": 649,
	"./cakes-images/black_forest.svg": 2537,
	"./cakes-images/blackcurrentFB.svg": 9922,
	"./cakes-images/bluebery.svg": 7794,
	"./cakes-images/butter_scotch.svg": 8425,
	"./cakes-images/cake_default.svg": 4312,
	"./cakes-images/choco_coffee.svg": 7744,
	"./cakes-images/choco_dark.svg": 3415,
	"./cakes-images/chocolate.svg": 3580,
	"./cakes-images/dutch-chocolate-heart-cake FB.svg": 6457,
	"./cakes-images/mango_crush.svg": 4044,
	"./cakes-images/pineappleFB.svg": 5248,
	"./cakes-images/pineapple_cake.svg": 9051,
	"./cakes-images/redv.svg": 8483,
	"./cakes-images/strawberry.svg": 5741,
	"./cakes-images/vanilla.svg": 9635,
	"./camera.svg": 1040,
	"./decorations/anniversary.svg": 3761,
	"./decorations/baby_shower.svg": 6094,
	"./decorations/birthday.svg": 702,
	"./decorations/celebrations.svg": 1142,
	"./decorations/congrats.svg": 7766,
	"./decorations/decoration_image_1.svg": 2053,
	"./decorations/entertainment.svg": 1193,
	"./decorations/love_proposal.svg": 6130,
	"./decorations/romantic_date.svg": 5591,
	"./flowers-img.svg": 8393,
	"./flowers/bouquet.svg": 225,
	"./flowers/rose.svg": 2911,
	"./flowers/rosebouquet.svg": 1738,
	"./flowers/singleflower.svg": 8499,
	"./heart-balloon_Anniversary.svg": 2030,
	"./party_props/HBD.svg": 2915,
	"./party_props/coldfire.svg": 3649,
	"./party_props/fog_effect.svg": 6579,
	"./party_props/fog_effect1.svg": 1256,
	"./party_props/fog_effect_back.svg": 9947,
	"./party_props/fog_effect_new.svg": 1308,
	"./party_props/hbdletters.svg": 1210,
	"./party_props/led_numbers.svg": 5965,
	"./party_props/led_old.svg": 5640,
	"./party_props/party_props.svg": 3234,
	"./party_props/party_props_default.svg": 3676,
	"./party_props/photoclippings.svg": 9698,
	"./party_props/photoclippings_back.svg": 4148,
	"./photos/photos_default.svg": 2232,
	"./props.svg": 462,
	"./rose.svg": 1932
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6567;